import HighlightedTable from 'components/HighlightedTable/HighlightedTable';
import { NotifyRoutingPlan } from 'schemas/NotifyRoutingPlan.schema';
import './TeamRoutingPlans.css';
import { capitaliseFirstChar, getMessagePlanStatusColour } from 'utils/formattingUtils';
import { NOTIFY_TO_SPI_STATUS_MAP } from 'utils/routingPlansUtils';
import { Tag } from 'nhsuk-react-components';

interface NotifyRoutingPlansTableProps {
  routingPlans: NotifyRoutingPlan[];
  onDelete: (plan: NotifyRoutingPlan) => void;
}

function NotifyRoutingPlansTable({ routingPlans, onDelete }: NotifyRoutingPlansTableProps) {
  if (routingPlans.length === 0) {
    return null;
  }

  const sortedPlans = routingPlans.toSorted((a, b) => {
    const leftName = a.routing_plan_name;
    const rightName = b.routing_plan_name;

    return leftName.localeCompare(rightName);
  });

  return (
    <HighlightedTable>
      <HighlightedTable.HeaderRow>
        <HighlightedTable.HeaderValue className="routing-plans-table__header-name">
          Name (
          {routingPlans.length}
          )
        </HighlightedTable.HeaderValue>
        <HighlightedTable.HeaderValue className="routing-plans-table__header-status">
          Status
        </HighlightedTable.HeaderValue>
        <HighlightedTable.HeaderValue className="routing-plans-table__header-actions" />
      </HighlightedTable.HeaderRow>
      {sortedPlans.map((plan, index) => {
        const planName = plan.routing_plan_name;
        const planId = plan.routing_plan_id ?? planName;
        const rowKey = planId || `routing-plan-${index}`;

        return (
          <HighlightedTable.Row key={rowKey} className={plan.status === 'DRAFT' ? 'routing-plans-table__row--draft' : undefined}>
            <HighlightedTable.Value>
              <div className="nhsuk-u-font-weight-bold">{planName}</div>

              {(plan.status === 'DRAFT' || plan.status === 'COMPLETED') && (
                <>
                  <div className="nhsuk-u-secondary-text-colour nhsuk-u-font-size-16">Routing plan ID:</div>
                  <div className="nhsuk-u-secondary-text-colour nhsuk-u-font-size-16">{planId}</div>
                </>
              )}

            </HighlightedTable.Value>
            <HighlightedTable.Value>
              <Tag modifier={getMessagePlanStatusColour(NOTIFY_TO_SPI_STATUS_MAP[plan.status])}>{capitaliseFirstChar(NOTIFY_TO_SPI_STATUS_MAP[plan.status])}</Tag>
            </HighlightedTable.Value>
            <HighlightedTable.Value>
              <button
                type="button"
                className="nhsuk-back-link__link routing-plans-table__delete-button"
                onClick={() => onDelete(plan)}
              >
                Delete
              </button>
            </HighlightedTable.Value>
          </HighlightedTable.Row>
        );
      })}
    </HighlightedTable>
  );
}

export default NotifyRoutingPlansTable;
